import { PaperworkStatuses } from '../../components/Paperwork/constants';
import { isEmptyObject, safeGet } from './object';

const isPaperworkCompleted = (booking: any) => {
  if (isEmptyObject(booking)) {
    return false;
  }
  return (
    booking.paperworkStatus === PaperworkStatuses.COMPLETE ||
    booking.paperwork_status === PaperworkStatuses.COMPLETE
  );
};

// faith can allow a patient to bypass paperwork from the facesheet modal in the queue
const isPaperworkBypassed = (booking: any) =>
  safeGet(booking, false)('isPaperworkBypassed') ||
  safeGet(booking, false)('is_paperwork_bypassed');

export { isPaperworkCompleted, isPaperworkBypassed };
